export default __webpack_public_path__ + "static/media/m-serviceInfo4.f8a1ffca.png";